import React, { useEffect, useState } from "react";
import { containerClassName } from "@/lib/container";

const SCROLL_THRESHOLD_PX = 24;

const NAV_LINKS = [
  { id: "services-link", label: "Services", href: "#services" },
  { id: "hiring-link", label: "Hiring", href: "#hiring" },
  { id: "approach-link", label: "Approach", href: "#approach" },
  { id: "industries-link", label: "Industries", href: "#industries" },
  { id: "specs-link", label: "Capabilities", href: "#specs" },
  { id: "reviews-link", label: "Reviews", href: "#reviews" },
  { id: "faq-link", label: "FAQ", href: "#faq" },
];

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-zinc-950/75 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className={`${containerClassName} h-16 flex items-center justify-between gap-4`}>
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-2.5 text-white font-black tracking-tight"
        >
          <img
            src="/logo.png"
            alt="Conquest IT Services"
            className="w-12 h-12 object-contain"
          />
          <span className="text-[17px]" style={{ fontFamily: "Outfit, sans-serif" }}>
            CONQUEST
          </span>
        </a>

        <nav className="hidden md:flex flex-1 items-center justify-center gap-5 lg:gap-7 xl:gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-${link.id}`}
              className="text-sm text-zinc-300 hover:text-white transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="navbar-cta"
          className="inline-flex items-center gap-2 bg-[#FF4500] hover:bg-[#ff5a1f] text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors duration-200"
        >
          Get in touch
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </header>
  );
};

export default NavBar;
